// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"405e3785","235":"f314e6ed","374":"699ad4d9","606":"fb285e34","617":"f314e6ed","818":"fa2edb0d","868":"699ad4d9"}[chunkId] + ".chunk.css";
};